import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { PromoText } from 'components/no-auth/common/PromoText/PromoText';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const ListConditions = styled.ul`
    list-style-type: none;
    margin: 0 16px 0 32px;
    padding: 0;

    li {
        color: ${promoColors.baseColor};
        font-size: 14px;
        line-height: 1.6;
        margin: 0;
        position: relative;
        padding: 0 0 0 16px;

        &::before {
            content: '•';
            font-size: 90%;
            left: 0;
            position: absolute;
            top: 0;
        }

        & + li {
            margin-top: 4px;
        }
    }

    ${promoMedia.tablet744} {
        li {
            font-size: 16px;
        }
    }

    a {
        color: inherit;
    }
`;

const RuleItem = (props) => {
    const addVersionToUrl = (url) => {
        const today = new Date();
        const tenMinutes = Math.floor(today.getMinutes() / 10);
        return url.concat('?v=', `${today.getDate()}:${today.getHours()}.${tenMinutes}`);
    };

    return (
        <ListConditions>
            {props.rules?.term_item
                .filter((item) => item !== null)
                .map((item, index) => {
                    return (
                        <li key={index}>
                            <PromoText tag="div" color="baseColor">
                                {item.url && item.title && (
                                    <a href={addVersionToUrl(item.url)} title={item.title} target="_blank">
                                        {item.title}
                                    </a>
                                )}
                                {item.title && !item.url ? item.title : ''}
                            </PromoText>

                            {Array.isArray(item.secondary_links) &&
                                item.secondary_links
                                    .filter((item) => item !== null)
                                    .map((link) => {
                                        return (
                                            <PromoText key={link.id} tag="div" color="baseColor">
                                                {link.link && link.title && (
                                                    <a href={addVersionToUrl(link.link)} title={link.title} target="_blank">
                                                        {link.title}
                                                    </a>
                                                )}
                                            </PromoText>
                                        );
                                    })}
                        </li>
                    );
                })}
        </ListConditions>
    );
};
RuleItem.propTypes = {
    rules: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
};
export default RuleItem;
